import React from "react";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import reloadIcon from "../../assets/icons/reloadIcon.svg";

const ReactErrorPage = ({
  resetErrorBoundary,
}: {
  resetErrorBoundary: React.MouseEventHandler<HTMLButtonElement>;
}): JSX.Element => {
  const { t } = useTranslation();

  return (
    <React.Fragment>
      <h1 style={{ textAlign: "center", marginTop: "100px", marginBottom: "40px" }}>{t("Ups! Coś poszło nie tak...")}</h1>
      {resetErrorBoundary && (
        <div className="d-flex justify-content-center">
          <Button variant="primary" size="lg" onClick={resetErrorBoundary}>
            <img src={reloadIcon} width={18} height={18} alt="Reload Alerts/ Remove Filters Icon" /> {t("Odśwież")}
          </Button>
        </div>
      )}
    </React.Fragment>
  );
};

export default ReactErrorPage;
